<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <a class="decoration">Rental</a>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Manage Rental Units
      </h6>

      <div style="padding-bottom: 120px;" class="container-fluid">
        <div style="border: 0; padding: 0; min-height: 0;" class="navbar background_color">
          <div class="d-flex flex-column flex-md-row flex-wrap gap-2">
            <b-input-group size="sm" class="w-100" style="max-width: 225px;">
              <b-form-input
                v-model="filter"
                @input="loadMiinventory()"
                type="search"
                placeholder="Search"
              />
            </b-input-group>

            <div class="ms-md-2 mt-2 mt-md-0">
              <span class="custom-breadcrumb d-block text-center text-md-start">
                <b>Showing {{ currentPage }} - {{ currentPage * perPage }} of {{ totalRows }} items.</b>
              </span>
            </div>
          </div>
        </div>

        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-else class="table-responsive">
              <b-table
                responsive
                class="table-hover"
                style="font-size: small;"
                :items="all_datas"
                :fields="fields"
                :current-page="currentPage"
                head-variant="dark"
                :filter="filter"
                :filter-included-fields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                show-empty
                small
                @filtered="onFiltered"
              >
                <template #cell(number)="row">
                  {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1) * 10 + row.index + 1 }}
                </template>

                <template #cell(actions)="row">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu bdr-rad">
                      <a class="dropdown-item mouse-cursor" @click="viewLoad(row.item)">View</a>
                    </div>
                  </div>
                </template>
              </b-table>

              <b-col style="padding-left: 0;" sm="7" md="2" class="my-1 mb-4">
                <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm" />
              </b-col>
            </div>
          </div>
        </div>

        <b-modal :id="infoModal.id" :title="infoModal.content.do_code" hide-footer>
          <div class="card">
            <div class="card-body">
              <table style="font-size: small;" class="table table-sm">
                <tbody>
                  <tr>
                    <td style="border: 0;"><b>Id</b></td>
                    <td style="border: 0;">{{ infoModal.content.id }}</td>
                  </tr>
                  <tr>
                    <td><b>Delivery Note No.</b></td>
                    <td>{{ infoModal.content.do_code }}</td>
                  </tr>
                  <tr>
                    <td><b>Delivery Date</b></td>
                    <td>{{ infoModal.content.do_date }}</td>
                  </tr>
                  <tr>
                    <td><b>Customer</b></td>
                    <td>{{ infoModal.content.C_name }}</td>
                  </tr>
                  <tr>
                    <td><b>Sales Person</b></td>
                    <td>{{ infoModal.content.name }}</td>
                  </tr>
                  <tr>
                    <td><b>Loading Point</b></td>
                    <td>{{ infoModal.content.loading_port }}</td>
                  </tr>
                  <tr>
                    <td><b>Driver Name</b></td>
                    <td>{{ infoModal.content.driver_name }}</td>
                  </tr>
                  <tr>
                    <td><b>Loading Vehicle No.</b></td>
                    <td>{{ infoModal.content.loading_vehicle_no }}</td>
                  </tr>
                  <tr>
                    <td><b>Status</b></td>
                    <td>{{ infoModal.content.status }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  name: 'RentalIndex',
  components: {
    TopNavbar,
    ContentFooter,
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      all_datas: [],
      filter: null,
      filterOn: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      isLoading: true,
      fields: [
        { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
        { key: 'do_code', label: 'Issue No.', sortable: true },
        { key: 'do_date', label: 'Issue Date', sortable: true },
        { key: 'C_name', label: 'Customer', sortable: true },
        { key: 'loading_port', label: 'Loading Point', sortable: true },
        { key: 'loading_vehicle_no', label: 'Loading Vehicle No.', sortable: true },
        { key: 'name', label: 'Sales Person', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'actions', label: 'Actions', class: 'width-custom3' },
      ],
      infoModal: {
        id: 'rental-info-modal',
        title: '',
        content: {},
      },
    };
  },
  mounted() {
    this.loadMiinventory();
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    isConfirmed(item) {
      return (item.status || '').toString().trim().toLowerCase() === 'confirmed';
    },
    async loadMiinventory() {
      this.isLoading = true;
      try {
        const params = new URLSearchParams({
          page: '1',
          perPage: '1000',
        });

        if (this.filter) {
          params.append('filter', this.filter);
        }

        const { data } = await axios.get('/ivehicledeliverynote/index?' + params.toString(), {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          },
        });
        console.log(data);
        this.all_datas = data.all_data || [];
        this.totalRows = data.total_count || this.all_datas.length || 0;
      } catch (error) {
        console.log(error.response);
        this.all_datas = [];
        this.totalRows = 0;
      } finally {
        this.isLoading = false;
      }
    },
    viewLoad(item) {
      this.infoModal.content = item;
      this.$bvModal.show(this.infoModal.id);
    },
  },
};
</script>
